import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinSubGroupAccount = createAsyncThunk(
    "subGroupAccount/getMin",
    async ({search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getMinMasterSubGroupAccount',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const getMinSubGroupAccountData = createAsyncThunk(
    "subGroupAccount/getMin",
    async ({search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getMinMasterSubAccount',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                let newObj = [];
                response.data.data.map((item) =>
                    newObj.push({
                        value: item.SubAccountID,
                        label: item.SubAccount,
                    })
                );
                return {data: newObj};
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)


export const getSubGroupAccount = createAsyncThunk(
    "subGroupAccount/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getMasterSubGroupAccount',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const insertSubGroupAccount = createAsyncThunk(
    "subGroupAccount/insert",
    async ({MainAccountID, SubAccountID, SubGroupAccount, SubGroupAccountID, SaldoNormal}, thunkAPI) => {
        let formData = new FormData();
        formData.append("MainAccountID", MainAccountID);
        formData.append("SubAccountID", SubAccountID);
        formData.append("SubGroupAccount", SubGroupAccount);
        formData.append("SubGroupAccountID", SubGroupAccountID);
        formData.append("SaldoNormal", SaldoNormal || "D");
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'insertMasterSubGroupAccount',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const updateSubGroupAccount = createAsyncThunk(
    "subGroupAccount/update",
    async ({MainAccountID, SubAccountID, SubGroupAccount, SubGroupAccountID, status, SaldoNormal}, thunkAPI) => {
        let formData = new FormData();
        formData.append("MainAccountID", MainAccountID);
        formData.append("SubAccountID", SubAccountID);
        formData.append("SubGroupAccount", SubGroupAccount);
        formData.append("SubGroupAccountID", SubGroupAccountID);
        formData.append("status", status);
        formData.append("SaldoNormal", SaldoNormal || "D");
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'updateMasterSubGroupAccount',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

const initialState = {
    message: "",
    minData: [],
    isMinFetching: false,
    isMinSuccess: false,
    isMinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const subGroupAccountSlice = createSlice({
    name: "subGroupAccount",
    initialState,
    reducers: {},
    extraReducers: {
        [getMinSubGroupAccount.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinSubGroupAccount.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinSubGroupAccount.pending]: (state) => {
            state.isMinFetching = true;
        },
        [getMinSubGroupAccountData.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinSubGroupAccountData.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinSubGroupAccountData.pending]: (state) => {
            state.isMinFetching = true;
        },


        [getSubGroupAccount.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getSubGroupAccount.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getSubGroupAccount.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertSubGroupAccount.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertSubGroupAccount.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertSubGroupAccount.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateSubGroupAccount.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateSubGroupAccount.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateSubGroupAccount.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});


export const subGroupAccountSelector = (state) => state.subGroupAccount;
